<span [class]="cssClass">
  <span class="readmore-text-content" #text [class]="cssClass">
    {{ outputText }}
  </span>
  <span *ngIf="shortened" class="readmore">... <a (click)="expand()" [class]="cssClass">read more</a></span>
</span>
